var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c("div", { staticClass: "media-dialog item__preview" }, [
        _c("div", { staticClass: "media-dialog__header" }, [
          _c(
            "button",
            {
              staticClass: "border-0 bg-transparent",
              on: { click: _vm.close },
            },
            [_c("i", { staticClass: "fas fa-2x fa-times" })]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "media-dialog__body" },
          [
            _vm.isVideo
              ? _c("video", { attrs: { controls: "" } }, [
                  _c("source", {
                    attrs: { src: _vm.source, type: _vm.mimeType },
                  }),
                  _vm._v(
                    "\n            Your browser doesn't support video, you may download the video "
                  ),
                  _c("a", { attrs: { href: _vm.source } }, [_vm._v("here")]),
                ])
              : _vm.isImage
              ? _c("el-image", { attrs: { fit: "contain", src: _vm.source } })
              : _c("span", [
                  _vm._v("Unsupported media, you may download it "),
                  _c("a", { attrs: { href: _vm.source } }, [_vm._v("here")]),
                ]),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }